module.exports = __webpack_public_path__ + "img/c11fc4f.jpg";